import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { PlatformHttpService } from '../../../services/platform-http.service';

export interface Kalibar {
  id?: number;
  name: string;
  shortCode?: string;
  description?: string;
  displayOrder: number;
  status: string;
  createdDate?: string;
  modifiedDate?: string;
  createdBy?: string;
  modifiedBy?: string;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

@Injectable({ providedIn: 'root' })
export class KalibarService {
  private platformHttp = inject(PlatformHttpService);
  private readonly baseUrl = '/api/v1/kalibars';

  getKalibars(page = 0, size = 20): Observable<PageResponse<Kalibar>> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.platformHttp.get(this.baseUrl, params) as Observable<PageResponse<Kalibar>>;
  }

  getKalibarById(id: number): Observable<Kalibar> {
    return this.platformHttp.get(`${this.baseUrl}/${id}`) as Observable<Kalibar>;
  }

  getActiveKalibars(): Observable<Kalibar[]> {
    return this.platformHttp.get(`${this.baseUrl}/active`) as Observable<Kalibar[]>;
  }

  createKalibar(kalibar: Kalibar): Observable<void> {
    return this.platformHttp.post(this.baseUrl, kalibar) as Observable<void>;
  }

  updateKalibar(id: number, kalibar: Kalibar): Observable<void> {
    return this.platformHttp.put(`${this.baseUrl}/${id}`, kalibar) as Observable<void>;
  }

  deleteKalibar(id: number): Observable<void> {
    return this.platformHttp.delete(`${this.baseUrl}/${id}`) as Observable<void>;
  }
}
